module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "id00018"
    }
  }, [_vm._v("LONDON")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00019"
    }
  }, [_vm._v("1905")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00020"
    }
  }, [_vm._v("PREFACE My readers of Forbidden Fruit may wish to know the origin of the work. It was this way, whilst I was staying at an out of the way village on the Sussex coast, I used to take long solitary walks, and several times saw a very beautiful girl sitting on a secluded part of the downs, attentively reading what looked like a manuscript in a black cover. Naturally I concluded she was some very studious young lady trying to improve her leisure, as she did not appear anything like the frivolous novel about what she was so intent upon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00021"
    }
  }, [_vm._v("One day, on the same foot-path, I picked up what I believed to be her manuscript book, and looking curiously at the contents, was surprised to find it was a tale of the grossest kind, scenes of love and lust depicted in the most realistic manner, with Prick, Cunt, Fuck and other things mentioned in the plainest language.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00022"
    }
  }, [_vm._v("I sat down on the bank to enjoy this unexpected voluptuous treat, when suddenly I was startled by a breathless exclamation of: \"That's my book! Oh, give it me back, Sir; I must have dropped it as I passed along here, a short time ago, and ran back to find it.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00023"
    }
  }, [_vm._v("\"Your book, Miss. I was just looking to see if there was any address in it, when I saw what it was about. Excuse my looking, it was done quite innocently, and your secret is safe with me.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00024"
    }
  }, [_vm._v("Realising at once the shame of the thing, she gasped for breath, flushed crimson, and then turning pale as death, fell fainting at my feet, before I could catch her in my arms.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00025"
    }
  }, [_vm._v("Reclining her against the mossy bank upon which I had been sitting, I rubbed and chafed her hands, squeezing her fingers quite painfully, in order to bring her to herself, but for several minutes without success, as there was no chance to obtain either water or brandy in such a place.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00026"
    }
  }, [_vm._v("Presently she murmured \"Fuck me! Shove in into me! I want it all—I must have it now;\" and a succession of bawdy expressions, quite shocking from the lips of such a young girl, as she could not be more than seventeen, at most.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00027"
    }
  }, [_vm._v("It was incredible she could be so depraved, but it seemed a striking confirmation of what a doctor once told me, viz, that even the most virtuous girls often use frightfully obscene words, when recovering from a fainting fit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00028"
    }
  }, [_vm._v("Anyhow, I resolved not to take advantage of her, and behave honourably to her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00029"
    }
  }, [_vm._v("As she came round a little she opened her eyes with the question: \"Oh! where am I?\" And catching sight of me holding her hands so tightly, all her shame returned to her in quite an overwhelming sense, and bursting into tears, she cried so bitterly, it was a long time before I could reassure her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00030"
    }
  }, [_vm._v("Promising to keep the secret of her book, I only asked one thing, and that was that she would not avoid me, and allow me to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00031"
    }
  }, [_vm._v("This of course led to a close friendship between us; I lent her a variety of voluptuous books, and she let me have the manuscript to copy for my printer, but would not impart to me how she came by it, saying: \"Some day, perhaps, after I am married, then I will let you Fuck me, and tell you all; it will not be long, my wedding is fixed to come off in two months time; I'm a virgin and mean to be so till I have my husband, but have to thank your forbearance that dreadful day when, you found my book, and did not take advantage of the situation. I both respect and love you for it.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00032"
    }
  }, [_vm._v("She would permit me every familiarity but the one thing. We Frigged, Sucked, and enjoyed every other pleasure, both abroad, and in my own rooms, where she would visit me, having perfect liberty, living with an old nurse of hers; so not a soul in the place knew anything about either of us.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "id00033"
    }
  }, [_vm._v("When we parted it was, \"Au Revoir,\" and some day I may have more to tell.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre4 sigil_not_in_toc",
    attrs: {
      "id": "id00034"
    }
  }, [_vm._v("THE AUTHOR.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797f803f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0